import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  icon: '🦴',
  situation: 'Alumno con lumbalgia crónica',
  without: 'Improvisás o evitás ciertos movimientos',
  with: 'Protocolo exacto: qué hacer, qué no, qué decirle'
}, {
  icon: '🤰',
  situation: 'Alumna embarazada',
  without: 'Miedo a lastimar o quedar mal',
  with: 'Guía por trimestre con movimientos adaptados'
}, {
  icon: '💊',
  situation: 'Alumno con hipertensión',
  without: 'No sabés qué está contraindicado',
  with: 'Protocolo claro de carga, FC y señales de alarma'
}, {
  icon: '🦴',
  situation: 'Alumno con osteoporosis',
  without: 'Evitás todo por las dudas',
  with: 'Qué sí y qué no según el grado de la condición'
}, {
  icon: '🧠',
  situation: 'Alumno con ansiedad severa',
  without: 'No sabés cómo modular la intensidad',
  with: 'WOD específico con progresión y respiración guiada'
}, {
  icon: '🚨',
  situation: 'Lesión en medio del WOD',
  without: 'Pánico y sin saber qué hacer',
  with: 'Protocolo de primeros auxilios paso a paso listo para actuar'
}, {
  icon: '🆕',
  situation: 'Alumno nuevo con condición especial',
  without: 'La ficha no te dice qué hacer con eso',
  with: 'Tabla de equivalencias: si tiene X condición, hacé Y adaptación'
}];
export function ComparisonTable() {
  return <section className="py-12 md:py-20 px-4 bg-cf-dark border-t border-white/5" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <div className="text-center mb-8 md:mb-12" data-id="element-73">
          <h2 className="font-bebas text-3xl md:text-6xl text-white tracking-tight mb-2 md:mb-4 leading-tight" data-id="element-74">
            ¿QUÉ AGREGA EL CROSSFIT PRO™?
          </h2>
          <p className="text-base md:text-xl text-cf-gold font-medium" data-id="element-75">
            El sistema que hace que ningún alumno sea "demasiado difícil"
          </p>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-3" data-id="element-76">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="rounded-lg border border-white/10 bg-cf-card overflow-hidden" data-id="element-77">
              <div className="flex items-center gap-2.5 px-3 py-2.5 bg-white/5 border-b border-white/10" data-id="element-78">
                <span className="text-xl leading-none" data-id="element-79">{row.icon}</span>
                <p className="text-white font-semibold text-[13px] leading-snug" data-id="element-80">
                  {row.situation}
                </p>
              </div>
              <div className="grid grid-cols-2 divide-x divide-white/10" data-id="element-81">
                <div className="p-3 bg-cf-red/5" data-id="element-82">
                  <div className="flex items-center gap-1 text-cf-red text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-83">
                    <X className="w-3 h-3" data-id="element-84" /> Sin Pro™
                  </div>
                  <p className="text-gray-400 text-xs leading-snug" data-id="element-85">
                    {row.without}
                  </p>
                </div>
                <div className="p-3 bg-cf-gold/5" data-id="element-86">
                  <div className="flex items-center gap-1 text-cf-gold text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-87">
                    <Check className="w-3 h-3" data-id="element-88" /> Con Pro™
                  </div>
                  <p className="text-gray-100 text-xs font-medium leading-snug" data-id="element-89">
                    {row.with}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Desktop: table */}
        <div className="hidden md:block overflow-x-auto pb-4" data-id="element-90">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-91">
            <thead data-id="element-92">
              <tr data-id="element-93">
                <th className="p-4 text-left border-b-2 border-white/10 w-1/3" data-id="element-94"></th>
                <th className="p-4 text-left border-b-2 border-cf-red/50 bg-cf-red/5 text-cf-red font-bold w-1/3" data-id="element-95">
                  <div className="flex items-center gap-2" data-id="element-96">
                    <X className="w-5 h-5" data-id="element-97" /> Sin Crossfit Pro™
                  </div>
                </th>
                <th className="p-4 text-left border-b-2 border-cf-gold bg-cf-gold/5 text-cf-gold font-bold w-1/3" data-id="element-98">
                  <div className="flex items-center gap-2" data-id="element-99">
                    <Check className="w-5 h-5" data-id="element-100" /> Con Crossfit Pro™
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-101">
              {rows.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-102">
                  <td className="p-4 text-white font-medium" data-id="element-103">
                    <div className="flex items-center gap-3" data-id="element-104">
                      <span className="text-2xl" data-id="element-105">{row.icon}</span>
                      {row.situation}
                    </div>
                  </td>
                  <td className="p-4 text-gray-400 bg-cf-red/5" data-id="element-106">
                    {row.without}
                  </td>
                  <td className="p-4 text-gray-200 bg-cf-gold/5 font-medium" data-id="element-107">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}